import React, { useState, FC } from "react";
import InputField from '../shared_components/input-field/InputField'
import TextButton from "../shared_components/text-button/TextButton";
import ErrorMessage from "../shared_components/error-message/ErrorMessage";
import { useLoginInput } from "../shared_components/useInput/useInput";
import validators from "../utilities/form_validators";
import useCases from "../use_cases";
import { Credentials } from "../shared_components/useInput/useInput";
import './Login.scss'

type LoginProps = {
  setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>
};


const Login: FC<LoginProps> = (props) => {
  const { setIsLoggedIn } = props
  const { setCredentials, credentials } = useLoginInput()
  const [emailIsValid, setEmailIsValid] = useState(true)
  const [error, setError] = useState('')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = event.target
    
    // reset the validator if the email was bad
    if (!emailIsValid) { setEmailIsValid(true) }
    
    setCredentials(name as keyof Credentials, value)
  }

  const loginSuccessful = () => {
    setIsLoggedIn(true)
  }

  const loginFailure = () => {
    setError("Login failed. Please check credentials and try again.")
  }

  const handleSubmit = (event: React.BaseSyntheticEvent) => {
    event.preventDefault()

    if (!validators.validateEmail(credentials.email)) {
      setEmailIsValid(false)
    }
    else {
      // hard coded to production, user account should be superuser
      useCases.login('production', { username: credentials.email, password: credentials.password }, {
        loginSuccessful, loginFailure
      });
    }
  }
  
  return (
    <div className='login-form-container'>
      <div className='login-title'>☆ kicktools</div>
      <form onSubmit={handleSubmit} className='login-form'>
        <div className="classkick-header">Account Login</div>
        <div>Please enter credentials for a super user account:</div>
        <InputField
          id='email-input'
          name='email'
          label='Email'
          type='text'
          className='input-field'
          handleChange={handleChange}
          value={credentials.email}
          testId='form-email'
          isValid={emailIsValid}
          errorMessage='Invalid email input, please try again.'
        />
        <InputField
          id='password-input'
          name='password'
          label='Password'
          type='password'
          className='input-field'
          handleChange={handleChange}
          value={credentials.password}
          testId='form-email'
          isValid={true}
          errorMessage='Please enter a valid password.'
        />
        <div className='separator' />
        <TextButton
          disabled={!credentials.email.length || !credentials.password.length}
          variant='primary'
          type='submit'
          buttonText="LOG IN"
          testId='form-submit'
        />
        {error && (
          <ErrorMessage message={error} id='UTP-error-div' className='error-div' testId='UTP-error-div-testId' />
        )}
      </form>
    </div>
  );
}

export default Login;
